import { forwardRef } from 'react';

import { useSlotRecipe } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons';

import { AutocompleteBaseItem } from './autocomplete-base-item';
import { AutocompleteItemProps } from './autocomplete-item.props';

export const AutocompleteAccommodationItem = forwardRef<HTMLLIElement, AutocompleteItemProps>(
    ({ itemCount, ...rest }: AutocompleteItemProps, ref): JSX.Element => {
        const recipe = useSlotRecipe({ key: 'autocompleteItem' });
        const styles = recipe();

        return (
            <AutocompleteBaseItem LeftIcon={IconsLinear.Building3} ref={ref} {...rest}>
                <IconsLinear.ArrowRight size={'sm'} {...styles.icon} />
            </AutocompleteBaseItem>
        );
    },
);

AutocompleteAccommodationItem.displayName = 'AutocompleteAccommodationItem';
